var React = require('react');

function SRedo18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.92713,5.92052,13.36927,2.67838a.22262.22262,0,0,0-.37966.157V5.2381H4.57869A4.28069,4.28069,0,0,0,1.61907,6.38357,4.41108,4.41108,0,0,0,.16193,10.12843,4.60538,4.60538,0,0,0,4.77621,14.1631l3.67605-.02024a.44363.44363,0,0,0,.44443-.44362l.01133-.752a.44361.44361,0,0,0-.44766-.44362H4.5455A2.92,2.92,0,0,1,1.82226,9.41524,2.68681,2.68681,0,0,1,4.5544,6.85714h8.43521V9.26062a.22262.22262,0,0,0,.37966.157l3.55786-3.183a.2202.2202,0,0,0,0-.3141Z","fill":"var(--iconFill, #464646)"}));
}

SRedo18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SRedo18;

SRedo18.default = SRedo18;
